export default __webpack_public_path__ + "static/media/table.cc5bdc1d.jpg";